module.exports = __webpack_public_path__ + "img/1576803539.f71b3acf.jpg";